<!-- 电子书
 -->

<template>
  <!-- 結縁品及下載 -->
  <div class="download">
    <div class="conten">
      <!-- api -->

      <div>
        <!-- PC版 -->
        <div class="downApk">
          <div class="title">安祥禅电子书 - PC版：</div>
          <div class="apiAddr">
            <!-- 繁体版 -->
            <span>繁体版：</span>
            <a
              target="_blank"
              :href="pc.complex_link"
              style="text-decoration: none; color: #3890d7"
            >
              anhsiangchan-ebook1.rar</a
            >
          </div>
          <div class="apiAddr">
            <!-- 简体版 -->
            <span>简体版：</span>
            <a
              target="_blank"
              :href="pc.simple_link"
              style="text-decoration: none; color: #3890d7"
            >
              anhsiangchan-ebook2.rar</a
            >
          </div>

          <div class="note flex-center"></div>
        </div>
        <!-- 安卓手机版 -->
        <div class="downApk">
          <div class="title">{{ $t("androidTitle") }}</div>
          <div class="apiAddr">
            <!-- 繁体版 -->
            <span>{{ $t("downEdition1") }}</span>
            <a
              target="_blank"
              :href="android.complex_link"
              style="text-decoration: none; color: #3890d7"
            >
              {{ android.title }}</a
            >
          </div>
          <div class="apiAddr">
            <!-- 简体版 -->
            <span>{{ $t("downEdition2") }}</span>
            <a
              target="_blank"
              :href="android.simple_link"
              style="text-decoration: none; color: #3890d7"
            >
              {{ android.remark }}</a
            >
          </div>

          <div class="note flex-center"></div>
        </div>
        <barF5></barF5>
        <!-- 苹果手机版 -->
        <div class="downApk">
          <div class="title">{{ $t("appleTitle") }}</div>
          <div class="apiAddr">
            <!-- 繁体版 -->
            <span>{{ $t("downEdition1") }}</span>
            <a
              target="_blank"
              :href="apple.complex_link"
              style="text-decoration: none; color: #3890d7"
            >
              {{ apple.title }}</a
            >
          </div>
          <div class="apiAddr">
            <!-- 简体版 -->
            <span>{{ $t("downEdition2") }}</span>
            <a
              target="_blank"
              :href="apple.simple_link"
              style="text-decoration: none; color: #3890d7"
            >
              {{ apple.remark }}</a
            >
          </div>

          <div class="note flex-center"></div>
        </div>
        <barF5></barF5>
      </div>

      <!-- 安祥禪電子書所包含的主要書目如下： -->
      <div class="firstDraft">
        <h3 class="title">{{ $t("includesBook") }}</h3>
        <div style="padding: 0.64rem; margin: 2rem 0rem">
          <table border="1" cellspacing="0" class="tableStyle">
            <tr v-for="(item, index) in catalog" :key="index">
              <td class="tableVirMidd W1">{{ $t("numList1")[index] }}</td>
              <td class="tableVirMidd W9 tl" @click="linkToDetail(item)">
                {{ item.name }}
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <!-- 底部button -->
    <!-- <footer>
            <Button></Button>
        </footer> -->
  </div>
</template>

<script>
// import{downloadFile} from '../../api/apis';
import { getCateList, getEbookList } from "../../api/apis";
import barF5 from "../../components/barF5"; //空隙bar
import Button from "../../components/button"; //返回首頁
export default {
  name: "show",
  components: {
    barF5,

    Button,
  },
  props: {
    // contentList: {
    //     type: Object,
    //     default: () => {}
    // }
  },
  data() {
    return {
      android: {},
      apple: {},
      pc:{},
      catalog: [],
      // baseUrl:"http://chanxue.b.langqiyun.cn/api/index/fileDownload?"
      baseUrl:
        "http://www.anhsiangchan.org.tw/api/index/fileDownload?",
    };
  },
  methods: {
    handleNote(str) {
      if (str) {
        return str.split("；") || str.split(";");
      } else {
        return [];
      }
    },
    //下载资源
    //  downLoad(item,title){
    //    window.location.href = this.baseUrl +`url=${item}&title=${title}`;
    // }
  },
  mounted() {
    // this.android = this.contentList.android || {};
    // this.apple = this.contentList.apple || {};
    // this.catalog = this.contentList.catalog || [];
  },
  created() {
    getCateList().then((res) => {
      let id = res[4][1].id;
      getEbookList(id).then((res) => {
        this.android = res.android || {};
        this.apple = res.apple || {};
        this.catalog = res.catalog || [];
        this.pc = res.pc || {}
      });
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.downApk {
  color: #333333;
  text-align: center;
  padding: 0.64rem;
}

.title {
  font-size: 0.8rem;
  line-height: 2rem;
  font-size: 0.85rem;
  font-weight: 600;
}

.apiAddr {
  font-size: 0.69rem;
  line-height: 2rem;
  font-size: 0.8rem;
}

.editAddr {
  color: #047bcd;
}

.note {
  color: #999999;
  line-height: 1rem;
  font-size: 0.59rem;
  font-size: 0.8rem;
}

.firstDraft {
  color: #333333;
  font-size: 0.69rem;
  font-size: 0.8rem;
}
.firstDraft .title {
  padding: 0.64rem;
  font-size: 0.8rem;
  line-height: 1.49rem;
  margin-bottom: 0.8rem;
  border-bottom: 0.1rem solid #dfdfdf;
  font-size: 0.85rem;
}
.tableStyle {
  width: 100%;
  text-align: center;
  padding: 0.64rem;
}

.tableVirMidd {
  display: table-cell;
  vertical-align: middle;
  line-height: 1.2rem;
}

table {
  border: 1px solid #999999;
}

th {
  border: 1px solid #999999;

  height: 3rem;
}

td {
  border: solid #999999;
  border-width: 1px 1px 1px 1px;
  padding: 0.4rem;
  line-height: 1.2rem;
  font-size: 0.85rem;
}
.td_content {
  padding: 1rem;
  text-align: left;
}
.f59 {
  font-size: 0.59rem;
}
.f80 {
  font-size: 0.8rem;
}
.W1 {
  width: 1rem;
}
.W2 {
  width: 2rem;
}
.W3 {
  width: 3rem;
}
.W9 {
  width: 9rem;
}
</style>